export default "__VITE_ASSET__DUM_RzAm__"